module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"
// module id = 10
// module chunks = 0 1